<template>
   <div >
       <div class="col-md-12 routercontainer" > 
            <div class="btn btn-success routerlinkstyle"><font-awesome-icon icon="image" /><router-link :to="{ name: 'Gallery', params: { item: 'PhotoGallery' } }">..Photo Gallery</router-link></div>
            <div class="btn btn-success routerlinkstyle" ><font-awesome-icon icon="video" /><router-link :to="{ name: 'Gallery', params: { item: 'VideoGallery' } }">..Video Gallery</router-link></div>
       </div>
     <div v-if="$route.params.item==='PhotoGallery'"><PhotoGallery/></div>
     <div v-if="$route.params.item==='VideoGallery'"><VideoGallery/></div>   
   </div>
</template>

<script>
import PhotoGallery from '@/components/GalleryItems/PhotoGallery'
import VideoGallery from '@/components/GalleryItems/VideoGallery'
  export default {
    name: 'Gallery',
    components: {
    PhotoGallery,
    VideoGallery
    },
    data () {
      return {
        msg: 'Gallery'
    }
  }
}

</script>

<style >
.routerlinkstyle
{
    background-color:rgb(10, 73, 82);
    letter-spacing: 0.5em;
    font-weight: bold;
}
.routercontainer
{
    text-align: center;
    padding-top: 25px;
}
</style>



// WEBPACK FOOTER //
// src/components/Gallery.vue